import { nodeGraphSpecSchema } from '@/core';
import { createVisualization, mapPropsToSpec, mapSpecToProps } from '../../../plugin-system';
import { NodeGraphIcon } from './NodeGraphIcon';
import { NodeGraphOptionsEditorSettings } from './NodeGraphOptionsEditorSettings';
import { NodeGraphPanel } from './NodeGraphPanel';
import {
  createInitialNodeGraphOptions,
  NODE_GRAPH_DATA_TYPE,
  NODE_GRAPH_PROP_TO_SPEC_MAPPING,
} from './node-graph-model';

/**
 * Panel plugin that renders a node graph from a `sum by(label_a, label_b)`
 * style PromQL query. Each resulting series collapses into a single link
 * keyed by its two grouping labels and the instant value.
 *
 * The current layout is a layered `DependencyMap`; the plugin name is kept
 * generic so future layouts (force, bespoke) can plug in without churning
 * the panel kind.
 */
export const NodeGraph = createVisualization(NodeGraphPanel, {
  dashboardConfig: {
    kind: 'NodeGraph',
    panelOptionsEditorComponents: [
      {
        label: 'Settings',
        content: NodeGraphOptionsEditorSettings,
      },
    ],
    createInitialOptions: createInitialNodeGraphOptions,
    mapSpecToProps: (spec) => mapSpecToProps(spec, NODE_GRAPH_PROP_TO_SPEC_MAPPING),
    mapPropsToSpec: (props) => mapPropsToSpec(props, NODE_GRAPH_PROP_TO_SPEC_MAPPING),
    supportedDataType: NODE_GRAPH_DATA_TYPE,
    schema: nodeGraphSpecSchema,
    icon: NodeGraphIcon,
  },
});

export type NodeGraphVizProps = React.ComponentProps<typeof NodeGraph.Viz>;
export type NodeGraphVizBaseProps = React.ComponentProps<typeof NodeGraph.VizBase>;
